import { render } from "./a-task-spent-time.vue?vue&type=template&id=dc6acca2&scoped=true"
import script from "./a-task-spent-time.vue?vue&type=script&lang=js"
export * from "./a-task-spent-time.vue?vue&type=script&lang=js"

import "./a-task-spent-time.vue?vue&type=style&index=0&id=dc6acca2&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6acca2"]])

export default __exports__